import type { PerDiemWorkOrderEmployeeListViewModel } from 'ab-viewModels/perDiemWorkOrderEmployee.viewModel';
import type PerDiemWorkOrderEmployee from 'ab-viewModels/perDiemWorkOrderEmployee.viewModel';

const PER_DIEM_REPORT_CSV_KEYS = [
	'Full Name',
	'Date',
	'Week Day',
	'Job',
	'Work Order',
	'Amount $',
	'Location',
	'Is Cancelled',
];

export const toCSVData = (viewModel: PerDiemWorkOrderEmployeeListViewModel): string[][] => {
	const header: string[] = PER_DIEM_REPORT_CSV_KEYS;

	const rows: string[][] = viewModel.list.map((_item: PerDiemWorkOrderEmployee) => {
		const isWOCanceled = _item.isWorkOrderCanceled ? 'Yes' : 'No';

		const _row: string[] = [
			_item.fullName,
			_item.dueDate,
			_item.weekDay,
			_item.jobCode,
			_item.workOrderCode,
			_item.perDiemAmount,
			_item.location,
			isWOCanceled,
		];
		return _row;
	});

	return [header, ...rows];
};
